import React, { useCallback } from 'react'
import Breadcrumb from '../../components/common/Breadcrumb'
import styled from '@emotion/styled'
import Loading from '../../components/common/Loading'
import { maternityDetail } from '../../constant/path'
import { useScreen } from '../../utils/responsive-helper'
import { useRouter } from '../../utils/helper'
import { useGetEClaimHistoryById } from '../../services/e-claim/e-claim-query'
import { UserClaimDocumentList, FileType, ClaimDocumentTypes } from '../../services/e-claim/e-claim-types'
import MaternityInfo from './MaternityInfo'
import MaternityForm from '../MaternityDetail/MaternityForm'
import { useMemo } from 'react'
import dayjs from 'dayjs'
import moment from 'moment'
import Headbar from '../../components/common/HeadBar'
import * as paths from '../../constant/path'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router'
import { setMaternityInfo } from '../../redux-store/maternity-reducer'
import config from '../../config'
import colors from '../../constant/colors'

export type InitialValueType = {
  name: string
  amountReceipt: number
  amountClaim: number
  receiptFile: string
  optionalFileUrl: string
  relativeTypeId: string
  receiptDate: string
  claimName: string
}

const MaternityHistoryDetail = () => {
  const { query } = useRouter<{ id: number }>()
  const history = useHistory()
  const dispatch = useDispatch()
  const { data: maternityItem, isLoading } = useGetEClaimHistoryById({ id: query.id })
  const {
    claim,
    userClaimAmount,
    userClaimAmountApprove,
    relativeId,
    slipDate,
  } = maternityItem || {}

  const receiptFile = useMemo(() => {
    if (!maternityItem?.documentTypes) return ''

    return maternityItem?.documentTypes?.filter(item => item.name === FileType.ReceiptFile)[0]?.files?.length > 0
      ? maternityItem.documentTypes.filter(item => item.name === FileType.ReceiptFile)[0].files[0].name
      : ''
  }, [maternityItem?.documentTypes])

  const optionalFileUrl = useMemo(() => {
    if (!maternityItem?.documentTypes) return ''

    return maternityItem?.documentTypes?.filter(item => item.name === FileType.OptionalFileUrl)[0]?.files?.length > 0
      ? maternityItem.documentTypes.filter(item => item.name === FileType.OptionalFileUrl)[0].files[0].name
      : ''
  }, [maternityItem?.documentTypes])

  const birthCertificate = useMemo(() => {
    if (!maternityItem?.documentTypes) return ''

    return maternityItem?.documentTypes?.filter(item => item.name === FileType.BirthCertificate)[0]?.files?.length > 0
      ? maternityItem.documentTypes.filter(item => item.name === FileType.BirthCertificate)[0].files[0].name
      : ''
  }, [maternityItem?.documentTypes])

  const otherDocument = useMemo(() => {
    if (!maternityItem?.documentTypes) return ''

    return maternityItem?.documentTypes?.filter(item => item.name === FileType.OtherDocument)[0]?.files?.length > 0
      ? maternityItem.documentTypes.filter(item => item.name === FileType.OtherDocument)[0].files[0].name
      : ''
  }, [maternityItem?.documentTypes])

  const initialValue = useMemo(() => {
    return {
      name: claim?.name || '',
      amountReceipt: userClaimAmount,
      amountClaim: userClaimAmountApprove,
      receiptFile,
      optionalFileUrl,
      birthCertificate,
      otherDocument,
      relativeTypeId: relativeId ? relativeId.toString() : '',
      receiptDate: slipDate,
      claimName: claim?.name || '',
    }
  }, [claim, userClaimAmount, userClaimAmountApprove, relativeId, slipDate, receiptFile, optionalFileUrl, birthCertificate, otherDocument])

  const disable = useMemo(() => {
    if (!maternityItem?.isApproved && (maternityItem?.isApproved !== null)) {
      return false
    } else {
      return true
    }
  }, [maternityItem?.isApproved])

  const onCreateNewMaternity = useCallback(async () => {
    if (maternityItem?.id === undefined) return

    dispatch(
      setMaternityInfo({
        name: maternityItem.claim.name || '',
        amountReceipt: maternityItem.userClaimAmount,
        amountClaim: maternityItem.userClaimAmountApprove,
        receiptFile,
        optionalFileUrl,
        birthCertificate,
        otherDocument,
        relativeTypeId: maternityItem.relativeId ? maternityItem.relativeId.toString() : '',
        receiptDate: maternityItem.slipDate,
        claimName: maternityItem.claim.name || '',
        receiptNo: maternityItem?.receiptNo || '',
      }),
    )

    history.push(maternityDetail({
      routeParam: {
        maternityId: maternityItem?.claimId
      },
      queryParam: {
        isCreateNew: 'true'
      }
    }))
  }, [maternityItem, history, dispatch, receiptFile, optionalFileUrl, birthCertificate, otherDocument])

  if (!maternityItem) return null

  return (
    <Loading loading={isLoading}>
      <div style={{ paddingTop: '24px' }}>
        <Headbar title={maternityItem?.claim.name || ''} backWard={paths.maternityHistory()} titleColor={colors.BLACK} />
        <MaternityInfo id={query.id} maternityItem={maternityItem} onCreateNewMaternity={onCreateNewMaternity} />
        <MaternityForm
          maternityItem={maternityItem}
          maternityId={maternityItem.claimId}
          initialValues={initialValue}
          allpayStatus={disable}
          isHistory={true}
          editable={false}
        />
      </div>
    </Loading>
  )
}

export default MaternityHistoryDetail
